import { fetchIntermediarySummary } from "services/summarySrv";

async function getDashSummary() {
    const res = await fetchIntermediarySummary();
    return res.data;
}

export { getDashSummary };